/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-cabriolet-bb6a8d9a--sprite",
  "use": "car-cabriolet-bb6a8d9a--sprite-usage",
  "viewBox": "0 0 51 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 51 20\" id=\"car-cabriolet-bb6a8d9a--sprite\"><path d=\"M8 7H2.28a1 1 0 00-.97 1.243l1.5 6a1 1 0 00.97.757H8m0-8l6.055-3.028a1 1 0 011.418 1.137L15 7M8 7h7m19 0h11a5 5 0 015 5v2a1 1 0 01-1 1h-5M34 7l-6.341-5.549C27.012.885 26 1.345 26 2.204V7m8 0h-8m18 8a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H16m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m7-8h11\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M30 13l4-6H15l3 6h12zM1.5 9H4v2H2m48-1h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
